/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * MICROSOFT_GRAPH_DEFAULT_ENDPOINT is the default Graph endpoint that is silently set on
 * the providers as the baseURL.
 */
export const MICROSOFT_GRAPH_DEFAULT_ENDPOINT = 'https://graph.microsoft.com';
/**
 * MICROSOFT_GRAPH_ENDPOINTS is a set of all the valid Graph URL endpoints.
 */
export const MICROSOFT_GRAPH_ENDPOINTS = new Set([
    MICROSOFT_GRAPH_DEFAULT_ENDPOINT,
    'https://graph.microsoft.us',
    'https://dod-graph.microsoft.us',
    'https://graph.microsoft.de',
    'https://microsoftgraph.chinacloudapi.cn',
    'https://canary.graph.microsoft.com'
]);
